import { render, staticRenderFns } from "./FlatsCounter.vue?vue&type=template&id=0e72ac4c&scoped=true&"
import script from "./FlatsCounter.vue?vue&type=script&lang=js&"
export * from "./FlatsCounter.vue?vue&type=script&lang=js&"
import style0 from "./FlatsCounter.vue?vue&type=style&index=0&id=0e72ac4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72ac4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e72ac4c')) {
      api.createRecord('0e72ac4c', component.options)
    } else {
      api.reload('0e72ac4c', component.options)
    }
    module.hot.accept("./FlatsCounter.vue?vue&type=template&id=0e72ac4c&scoped=true&", function () {
      api.rerender('0e72ac4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/FlatsCounter.vue"
export default component.exports